import {  useContext, useEffect, useState } from 'react';
import ActionButton from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import { Search } from "../../../filtering";
import { pimsHouseDownloadList, TableColumn, TableSettings } from '../../../tableSettings';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../AbstractListView";
import JobListViewContext from '../JobListViewContext';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,IndicatorRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import { JobNames } from '../../../framework.core/JobNames';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../ListViewShortcutMenu';
import * as XCol from '../../../framework.core/XExportColumn';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import { PimsVanningListItem } from '../../../fms.data/models/PimsVanningListItem';
import ApplicationContext from '../../../ApplicationContext';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { useHistory } from 'react-router';

import IconButton, { ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import BlockIcon2 from '../../../img/Block2.svg';
import BlockIcon2_D from '../../../img/Block_Dark.svg';
import CBlockIcon2 from '../../../img/Cancel Block2.svg';
import CBlockIcon2_D from '../../../img/Cancel Block_Dark2.svg';
import DownIcon2 from '../../../img/AMS - Download to OI2.svg';
import DownIcon2_D from '../../../img/AMS - Download to OI_Dark2.svg';
import MoreMenuICon2 from '../../../img/More Menu2.svg';
import MoreMenuICon2_D from '../../../img/More Menu_Dark2.svg';

function formatData(data: Array<PimsVanningListItem>) {
  return data;
}

function useSelectedDownloadItem() {
  const jobListContext = useContext(JobListViewContext);

  const selectedElement = jobListContext.selectedElement as PimsVanningListItem | null;

  function view() {
    jobListContext.showPopupRow();
  }

  return { selectedElement, view };
}

function DownloadListCommands({ context }: {
  context: JobNames.OIHMyPims | JobNames.OIHPims | JobNames.OEHMyPims | JobNames.OEHPims |
  JobNames.AIHMyPims | JobNames.AIHPims | JobNames.AEHMyPims | JobNames.AEHPims
}) {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  
  const { selectedElement } = useSelectedDownloadItem();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const history = useHistory();
  
  let title = 'Download HBL';
  let buttonCatpion = 'Download to OI';

  switch (context) {
    case JobNames.OIHPims:
    case JobNames.OEHPims:
      title = 'Download HBL';
      break;
    case JobNames.AIHPims:
    case JobNames.AEHPims:
      title = 'Download HAWB';
      break;
  }

  switch (context) {
    case JobNames.OIHPims:
      buttonCatpion = 'Download to OI';
      break;
    case JobNames.OEHPims:
      buttonCatpion = 'Download to OE';
      break;
    case JobNames.AIHPims:
      buttonCatpion = 'Download to AI';
      break;
    case JobNames.AEHPims:
      buttonCatpion = 'Download to AE';
      break;
  }

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(context, id, isBlock);

      jobListContext.reloadData();
    }
  }

  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${context}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  return (
    <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      {/* <ViewIconButton2
        disabled={!selectedElement}
        onClick={() => showView(true)}
        useText
        /> */}
      <div className='ifms-common-vertical-gap-8'>
      <IconButton
        disabled={!selectedElement}
        onClick={() => block(true)}
        data-tooltip='Block' icon={appContext.useDarkMode ? BlockIcon2_D : BlockIcon2} useText>
      </IconButton>
      <IconButton
        disabled={!selectedElement}
        onClick={() => block(false)}
        data-tooltip='Cancel Block' icon={appContext.useDarkMode ? CBlockIcon2_D : CBlockIcon2}
        useText
      >
      </IconButton>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <IconButton
        disabled={!selectedElement}
        onClick={() => viewDownloadView()}
        data-tooltip={buttonCatpion} icon={appContext.useDarkMode ? DownIcon2_D : DownIcon2}
        useText
      >
      </IconButton>
      <ActionButton
       // type= {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? 'primary' : 'iconButton'}
        type='primary'
        variant="plain"
        tooltip='More Menu'
        size='extrasmall'
        items={[
          { label: `${title} (All) List` },
          { label: `${title} (Downloaded) List` },
          { label: `${title} (Ready to Download) List` },
        ]}
        // useInList = {appContext.suntekSettings?.company?.billingsTabVersion !== 2}
        useInList={false}
      >
        {/* <img src={appContext.useDarkMode ? MoreMenuICon2_D : MoreMenuICon2} alt="" /> */}
      </ActionButton></div>
      {/* <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View Voyage" width="760px"> */}
        {/* <ViewVoyage onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} /> */}
      {/* </IfmsModal> */}
    </div>
  );
}

function DownloadListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function HouseDownloadListViewExtras() {
  useFunctionKeys({ onFunction: onFunctionKey });

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OiPims}
      jobId={(jobListContext.selectedElement as PimsVanningListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Download List screen
 *
 * @class HouseDownloadListView
 * @extends {AbstractListView}
 */
class HouseDownloadListView extends AbstractListView {
  private jobName: JobNames.OIHMyPims | JobNames.OIHPims | JobNames.OEHMyPims | JobNames.OEHPims |
    JobNames.AIHMyPims | JobNames.AIHPims | JobNames.AEHMyPims | JobNames.AEHPims;

  constructor(jobName: JobNames.OIHMyPims | JobNames.OIHPims | JobNames.OEHMyPims | JobNames.OEHPims |
    JobNames.AIHMyPims | JobNames.AIHPims | JobNames.AEHMyPims | JobNames.AEHPims) {
    super();
    this.jobName = jobName;
  }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(this.jobName,
      'PimsVanningListItem',
      PimsVanningListItem.calculateSearchParameters(search, PimsVanningListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }


  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(this.jobName, 'PimsVanningListItem',
      PimsVanningListItem.calculateSearchParameters(search, PimsVanningListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getRowRenderers(): ListRowRenderer[] {
    return PimsVanningListItem.getExportCollection(this.jobName).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") colRenderer.Cell = IndicatorRenderer;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'id')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} useComma={false} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});    
    colRenderer.push({ accessor: 'id', changedValue: (value: any) => { return value['id'] } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = pimsHouseDownloadList;
    const cols = PimsVanningListItem.getExportCollection(this.jobName);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <DownloadListCommands context={this.jobName} />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <DownloadListToolbar />
    );
  }

  renderExtras() {
    return <HouseDownloadListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    switch (this.jobName) {
      case JobNames.OIHPims:
      case JobNames.OEHPims:
        return 'Download HBL List';
      case JobNames.AIHPims:
      case JobNames.AEHPims:
        return 'Download HAWB List';
      case JobNames.OIHMyPims:
      case JobNames.OEHMyPims:
        return 'Download MY HBL List';
      case JobNames.AIHMyPims:
      case JobNames.AEHMyPims:
        return 'Download MY HAWB List';
    }
  };
};

export default HouseDownloadListView;
